import { ipcFacade as ipcRenderer } from 'src/browser/apis/browserIpcApi';
import { IpcEventType } from 'src/common/constants/events';
import { HotkeyHandler, eventMap } from 'src/common/utils/keyboardEvents';

export function bindCommands() {
  ipcRenderer.on(IpcEventType.KEYBOARD_EVENT, (which: HotkeyHandler) =>
    eventMap[which]()
  );
}
